import { Plus, Trash2 } from 'lucide-react';
function formatDate(iso) {
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export default function Sidebar({ notes, activeId, onSelect, onCreate, onDelete }) {
  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h3>Recording notes</h3>
        <button className="btn-primary" onClick={onCreate}>
          <Plus aria-hidden="true" /> New note
        </button>
      </div>
      <ul className="note-list">
        {notes.map((note) => (
          <li
            key={note.id}
            className={`note-list-item ${note.id === activeId ? 'active' : ''}`}
            onClick={() => onSelect(note.id)}
          >
            <button type="button" className="note-list-item-main" onClick={() => onSelect(note.id)} style={{ textAlign: 'left' }}>
              <span className="note-title">{note.title || 'Untitled note'}</span>
              <span className="note-preview">{note.preview || 'No content yet'}</span>
            </button>
            <div className="note-meta">
              <span>{formatDate(note.updated_at)}</span>
              <button
                className="btn-icon"
                title="Delete note"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(note.id);
                }}
              >
                <Trash2 aria-hidden="true" />
              </button>
            </div>
          </li>
        ))}
        {notes.length === 0 && <li className="note-list-empty">No notes yet — create one!</li>}
      </ul>
    </aside>
  );
}
